<div class="body-main">
  <app-navbar></app-navbar>
  <div class="page container-fluid">
    <div class="row justify-content-center">
      <div class="col col-12 col-lg-10 col-xl-8">
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-footer class="d-lg-block"></app-footer>
  </div>
</div>
